var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStep01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 96,
    viewBox: "0 0 95 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1410_46025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0472 78.8113C59.851 78.8113 75.0945 63.5678 75.0945 44.764C75.0945 25.9603 59.851 10.7168 41.0472 10.7168C22.2435 10.7168 7 25.9603 7 44.764C7 63.5678 22.2435 78.8113 41.0472 78.8113Z",
    fill: "#F2F3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8049 33.1875H27.1355V83.7751H68.8049V33.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8122 85.4308H27.1355C26.2276 85.4308 25.488 84.6913 25.488 83.7834V33.1885C25.488 32.2805 26.2276 31.541 27.1355 31.541H68.8049C69.7128 31.541 70.4523 32.2805 70.4523 33.1885V83.776C70.4523 84.684 69.7128 85.4235 68.8049 85.4235L68.8122 85.4308ZM28.7829 82.1359H67.1574V34.8359H28.7829V82.1286V82.1359Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.732 29.168H41.2083V37.9397H54.732V29.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7393 39.5881H41.2156C40.3076 39.5881 39.5681 38.8486 39.5681 37.9407V29.1689C39.5681 28.261 40.3076 27.5215 41.2156 27.5215H54.7393C55.6472 27.5215 56.3867 28.261 56.3867 29.1689V37.9407C56.3867 38.8486 55.6472 39.5881 54.7393 39.5881ZM42.8557 36.2932H53.0845V30.8164H42.8557V36.2932Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2813 62.0163L53.7437 70.4073L62.1273 68.8697L85.3527 45.6444L78.5066 38.791L55.2813 62.0163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7436 72.0543C53.3116 72.0543 52.887 71.8859 52.5794 71.571C52.1987 71.1903 52.023 70.6411 52.1255 70.1066L53.6631 61.723C53.7217 61.3935 53.8828 61.0933 54.1171 60.859L77.3424 37.6336C77.9867 36.9893 79.0264 36.9893 79.6708 37.6336L86.5168 44.4797C87.1612 45.124 87.1612 46.1638 86.5168 46.8081L63.2915 70.0334C63.0572 70.2677 62.7497 70.4288 62.4202 70.4874L54.0365 72.025C53.9413 72.047 53.8388 72.0543 53.7363 72.0543H53.7436ZM56.8115 62.8213L55.7938 68.3494L61.3219 67.3316L83.0169 45.6366L78.4993 41.1189L56.8042 62.8139L56.8115 62.8213Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0939 67.8939L85.3527 45.6424L78.5066 38.7891L56.2478 61.0479",
    fill: "#F2F3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0938 69.5419C62.6692 69.5419 62.2518 69.3808 61.9296 69.0586C61.2853 68.4143 61.2853 67.3746 61.9296 66.7302L83.017 45.6429L78.4993 41.1253L57.412 62.2126C56.7676 62.8569 55.7279 62.8569 55.0836 62.2126C54.4393 61.5682 54.4393 60.5285 55.0836 59.8842L77.3424 37.6253C77.9575 37.0103 79.0558 37.0103 79.6708 37.6253L86.5169 44.4714C87.1612 45.1157 87.1612 46.1555 86.5169 46.7998L64.258 69.0586C63.9359 69.3808 63.5112 69.5419 63.0938 69.5419Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9156 50.982C80.4909 50.982 80.0736 50.8209 79.7514 50.4987L73.6522 44.3995C73.0079 43.7552 73.0079 42.7155 73.6522 42.0711C74.2965 41.4268 75.3363 41.4268 75.9806 42.0711L82.0798 48.1704C82.7241 48.8147 82.7241 49.8544 82.0798 50.4987C81.7576 50.8209 81.333 50.982 80.9156 50.982Z",
    fill: "#B3B8C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1410_46025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 74.7135,
    fill: "white",
    transform: "translate(7 10.7168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep01);
export default __webpack_public_path__ + "static/media/icon_step01.f02b663f538be0ecb7f8dddd08ae2c55.svg";
export { ForwardRef as ReactComponent };